import { render, staticRenderFns } from "./target-type-card.vue?vue&type=template&id=05b7e2a8&scoped=true&"
import script from "./target-type-card.vue?vue&type=script&lang=js&"
export * from "./target-type-card.vue?vue&type=script&lang=js&"
import style0 from "./target-type-card.vue?vue&type=style&index=0&id=05b7e2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7e2a8",
  null
  
)

/* custom blocks */
import block0 from "./target-type-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports